webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "Ue/Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cilB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__("cilB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("rMlB");




if (false) {
  // Enable Preact debug output and use of React Developer Tools
  //require('preact/debug')
}

var root = void 0;
function init() {
  var App = __webpack_require__("pnOm").default;
  root = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(App, null), document.querySelector('#app'), root);
}

if (false) {
  module.hot.accept('./App', init);
}

init();

/***/ }),

/***/ "pnOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__("Ue/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor__ = __webpack_require__("sMBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact__ = __webpack_require__("rMlB");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  App.prototype.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_2_preact__["b" /* h */])(
      'div',
      { className: 'App' },
      Object(__WEBPACK_IMPORTED_MODULE_2_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_Editor__["a" /* default */], null)
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_2_preact__["a" /* Component */]);



/***/ }),

/***/ "sMBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("rMlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_organism__ = __webpack_require__("F86v");



var styles = {
  tagNameEditor: {
    display: 'block',
    width: '100%',
    resize: 'none'
  },
  textarea: {
    display: 'block',
    width: '100%',
    height: '50vh',
    resize: 'none'
  },
  previewOuter: {
    marginTop: '1rem'
  }
};

var View = function View(_ref) {
  var content = _ref.content,
      tagName = _ref.tagName,
      _ref$handlers = _ref.handlers,
      changeContent = _ref$handlers.changeContent,
      changeTagName = _ref$handlers.changeTagName;

  var Tag = tagName || 'span';
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('textarea', { value: tagName, rows: 1, onInput: changeTagName, style: styles.tagNameEditor }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('textarea', { value: content, rows: 20, onInput: changeContent, style: styles.textarea }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { style: styles.previewOuter },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        Tag,
        { className: content },
        'Hello'
      )
    )
  );
};

var handlers = {
  initial: function initial() {
    return {
      tagName: 'button',
      content: '\ntext-white\nbg-pink\np-3\nrounded-lg\nhover:bg-red\n'.trim()
    };
  },

  changeContent: function changeContent(props, _ref2) {
    var value = _ref2.target.value;
    return { content: value };
  },
  changeTagName: function changeTagName(props, _ref3) {
    var value = _ref3.target.value;
    return { tagName: value };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_preact_organism__["a" /* default */])(View, handlers));

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.c8233e23.js